import cx from "classnames";
import DashboardOverview from "./overview";
import VideoChart from "./videoChart";

const VideoDashboard = ({ video }) => {
    return (
        <>
            <div className="card-body pt-0 pb-0">
                <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
                    <li className="nav-item mt-2">
                        <span className={cx("nav-link text-active-primary ms-0 me-10 py-5 active")}>Basic</span>
                    </li>
                </ul>
            </div>
            <DashboardOverview video={video} />
            <VideoChart video={video} />
        </>
    );
};

export default VideoDashboard;
